import { Link, useLocation } from "react-router-dom";
import { RB100_LOGO } from "../lib/api";

export const Navbar = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <nav
      data-testid="main-navbar"
      className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-rb-border"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo-link"
          className="flex items-center group"
        >
          <div className="bg-white p-1 h-20 w-20 sm:h-24 sm:w-24 flex items-center justify-center border border-rb-border">
            <img
              src={RB100_LOGO}
              alt="RB100 — Since 2002"
              className="h-full w-full object-contain"
            />
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-4">
          {!isAdmin && (
            <>
              <a
                href="/#about"
                data-testid="nav-link-about"
                className="hidden sm:inline-block text-sm font-medium text-rb-textMuted hover:text-rb-ink transition-colors px-3 py-2"
              >
                عن النادي
              </a>
              <a
                href="/#gallery"
                data-testid="nav-link-gallery"
                className="hidden sm:inline-block text-sm font-medium text-rb-textMuted hover:text-rb-ink transition-colors px-3 py-2"
              >
                المعرض
              </a>
              <a
                href="/#contact"
                data-testid="nav-link-contact"
                className="bg-rb-red hover:bg-rb-redHover text-white font-bold px-5 py-2.5 transition-colors text-sm"
              >
                تواصل معنا
              </a>
            </>
          )}
          {isAdmin && (
            <span className="text-xs tracking-widest text-rb-textMuted uppercase">
              لوحة الإدارة
            </span>
          )}
        </div>
      </div>
    </nav>
  );
};
